import React, { useEffect } from "react";
import { Table } from 'antd';
import { connect } from "react-redux";
import { 
	getPayrunNDList, doPayrunNDUpdate
} from "../../../../redux/payrun/payrunState";
import { NumberFormatter } from "../../../../utils/index";
import InputSaveOnChange from "components/fields/InputSaveOnChange";

const PayrunNdTable = (props) => {
	
  const { payrunNDList, getPayrunNDs, payrunId, mode, updateNDValue } = props;

  const doSaveNDValueChanged = (value, record, field, paycodeId) => {
    updateNDValue({'id':record.pnd_id, value, field, paycodeId});
  }

  const columns = [
    {
        title: `Date`,
        dataIndex: 'pnd_date',
        key: 'pnd_date',
        width: 100,  
        fixed: 'left',   
    },
    {
        title: `ND`,
        dataIndex: 'pnd_hours',
        key: 'pnd_hours',
        width: 100,
        render: (pnd_hours, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pnd_hours"
                    paycodeId={15} 
                    mode={mode} 
                    saveValueHandler={doSaveNDValueChanged}
                />
    },
    {
        title: `REG OT ND`,
        dataIndex: 'pnd_reg_ot_nd',
        key: 'pnd_reg_ot_nd',
        width: 100,
       render: (pnd_reg_ot_nd, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pnd_reg_ot_nd"
                    paycodeId={16} 
                    mode={mode} 
                    saveValueHandler={doSaveNDValueChanged}
                />
    },
    {
        title: `RD ND`,
        dataIndex: 'pnd_rd_nd',
        key: 'pnd_rd_nd',
        width: 100,
        render: (pnd_rd_nd, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pnd_rd_nd"
                    paycodeId={17} 
                    mode={mode} 
                    saveValueHandler={doSaveNDValueChanged}
                />
    },
    {
        title: `RD OT ND`,
        dataIndex: 'pnd_rd_ot_nd',
        key: 'pnd_rd_ot_nd',
        width: 100,
        render: (pnd_rd_ot_nd, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pnd_rd_ot_nd"
                    paycodeId={18} 
                    mode={mode} 
                    saveValueHandler={doSaveNDValueChanged}
                />
    },
    {
        title: `RH ND`,
        dataIndex: 'pnd_rh_nd',
        key: 'pnd_rh_nd',
        width: 100,
        render: (pnd_rh_nd, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pnd_rh_nd"
                    paycodeId={19} 
                    mode={mode} 
                    saveValueHandler={doSaveNDValueChanged}
                />
    },
    {
        title: `RH OT ND`,
        dataIndex: 'pnd_rh_ot_nd',
        key: 'pnd_rh_ot_nd',
        width: 100,
        render: (pnd_rh_ot_nd, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pnd_rh_ot_nd"
                    paycodeId={20} 
                    mode={mode} 
                    saveValueHandler={doSaveNDValueChanged}
                />
    },    
    {
        title: `RH RD ND`,
        dataIndex: 'pnd_rh_rd_nd',
        key: 'pnd_rh_rd_nd',
        width: 100,
        render: (pnd_rh_rd_nd, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pnd_rh_rd_nd"
                    paycodeId={21} 
                    mode={mode} 
                    saveValueHandler={doSaveNDValueChanged}
                />
    },
    {
        title: `RH RD OT ND`,
        dataIndex: 'pnd_rh_rd_ot_nd',
        key: 'pnd_rh_rd_ot_nd',
        width: 100,
        render: (pnd_rh_rd_ot_nd, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pnd_rh_rd_ot_nd"
                    paycodeId={22} 
                    mode={mode} 
                    saveValueHandler={doSaveNDValueChanged}
                />
    },
    {
        title: `SH ND`,
        dataIndex: 'pnd_sh_nd',
        key: 'pnd_sh_nd',
        width: 100,
        render: (pnd_sh_nd, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pnd_sh_nd"
                    paycodeId={23} 
                    mode={mode} 
                    saveValueHandler={doSaveNDValueChanged}
                />
    },
    {
        title: `SH OT ND`,
        dataIndex: 'pnd_sh_ot_nd',
        key: 'pnd_sh_ot_nd',
        width: 100,
        render: (pnd_sh_ot_nd, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pnd_sh_ot_nd"
                    paycodeId={24} 
                    mode={mode} 
                    saveValueHandler={doSaveNDValueChanged}
                />
    },
    {
        title: `SH RD ND`,
        dataIndex: 'pnd_sh_rd_nd',
        key: 'pnd_sh_rd_nd',
        width: 100,
        render: (pnd_sh_rd_nd, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pnd_sh_rd_nd"
                    paycodeId={25} 
                    mode={mode} 
                    saveValueHandler={doSaveNDValueChanged}
                />
    },
    {
        title: `SH RD OT ND`,
        dataIndex: 'pnd_sh_rd_ot_nd',
        key: 'pnd_sh_rd_ot_nd',
        width: 100,
        render: (pnd_sh_rd_ot_nd, record) => 
                <InputSaveOnChange 
                    className="text-right"
                    record={record} 
                    field="pnd_sh_rd_ot_nd"
                    paycodeId={26} 
                    mode={mode} 
                    saveValueHandler={doSaveNDValueChanged}
                />
    },
    {
        title: `Total ND`,
        dataIndex: 'pnd_total_nd_hours',
        key: 'pnd_total_nd_hours',
        width: 100,
        fixed: 'right',  
        render: (pnd_total_nd_hours) => <div>{NumberFormatter(pnd_total_nd_hours)}</div>      
    },
    ];
	
	useEffect(() => {
	    if (payrunId > 0) {
	        getPayrunNDs({payrunId: payrunId, paginate: 0, pivot: 1});
	    }
	}, [getPayrunNDs, payrunId]);
	
  	return (
  		<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
  			<Table
    			dataSource={payrunNDList} 
	        	columns={columns} 
	            rowKey={(record) => record.pdt_id}
	            pagination={false}
	            scroll={{
			      x: 1300,
			      y: 420,
			    }}
    		/>
  		</div>
  	);
};

const mapStateToProps = (state) => ({
	payrunNDList: state.payrun.payrunNDList?.items,
});

const mapDispatchToProps = (dispatch) => ({
	getPayrunNDs: (id) => dispatch(getPayrunNDList(id)),
    updateNDValue: (data) => dispatch(doPayrunNDUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayrunNdTable);